import { useEffect, useRef } from 'react';

export default function useReveal() {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const items = el.querySelectorAll('.reveal');
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    items.forEach((i) => io.observe(i));
    // Safety net: never let content stay invisible if the observer misfires.
    const fallback = setTimeout(() => {
      items.forEach((i) => i.classList.add('in'));
    }, 1500);
    return () => {
      clearTimeout(fallback);
      io.disconnect();
    };
  }, []);
  return ref;
}
